module.exports = __webpack_public_path__ + "img/home-victorian-stairs.c6c62e36.jpg";